const RESERVED_DOMAINS = new Set<string>([
    "kick.co",
    "kick.com",
    "sendgrid.net",
    "gmail.com",
    "googlemail.com",
    "outlook.com",
    "hotmail.com",
    "live.com",
    "msn.com",
    "yahoo.com",
    "ymail.com",
    "icloud.com",
    "me.com",
    "aol.com",
    "proton.me",
    "protonmail.com",
]);

/**
 * Kick-owned domains and consumer mailbox providers can never be registered as
 * sending domains (anti-spoofing). SMTP `host` may still point at these; only
 * the sending domain is restricted.
 */
export function isReservedDomain(domain: string): boolean {
    const normalized = domain.trim().toLowerCase();
    if (RESERVED_DOMAINS.has(normalized)) {
        return true;
    }
    return normalized === "kick.co" || normalized.endsWith(".kick.co");
}
